import { useState } from 'react'
import { Form, Input, Button, message } from 'antd'
import { userApi } from '../../services/api'

const SettingsSecurity = () => {
  const [passwordForm] = Form.useForm()
  const [loading, setLoading] = useState(false)

  const handlePasswordChange = () => {
    passwordForm.validateFields().then(values => {
      const payload = {
        currentPassword: values.currentPassword,
        newPassword: values.newPassword,
        confirmPassword: values.confirmPassword,
      }
      setLoading(true)
      userApi.changePassword(payload)
        .then(() => {
          message.success('密码修改成功，请使用新密码重新登录')
          passwordForm.resetFields()
        })
        .catch((error: any) => {
          message.error(error?.friendlyMessage ?? '密码修改失败，请重试')
        })
        .finally(() => setLoading(false))
    })
  }

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold mb-2">安全设置</h1>
        <p className="text-gray-600">密码设置</p>
      </div>
      <div className="max-w-md">
        <div className="text-lg font-medium mb-4">密码修改</div>
        <Form form={passwordForm} layout="vertical">
          <Form.Item label="当前密码" name="currentPassword" rules={[{ required: true, message: '请输入当前密码' }]}>
            <Input.Password placeholder="请输入当前密码" />
          </Form.Item>
          <Form.Item label="新密码" name="newPassword" rules={[{ required: true, message: '请输入新密码' }, { min: 8, message: '密码长度至少8位' }]}>
            <Input.Password placeholder="请输入新密码" />
          </Form.Item>
          <Form.Item
            label="确认新密码"
            name="confirmPassword"
            rules={[
              { required: true, message: '请确认新密码' },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('newPassword') === value) return Promise.resolve()
                  return Promise.reject(new Error('两次输入的密码不一致'))
                },
              }),
            ]}
          >
            <Input.Password placeholder="请确认新密码" />
          </Form.Item>
          <Form.Item>
            <Button type="primary" onClick={handlePasswordChange} loading={loading}>修改密码</Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  )
}

export default SettingsSecurity
